module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keep-alive', [_c('router-view', {
    attrs: {
      "shop": _vm.shop
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfcc392a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/member/member.vue
// module id = 838
// module chunks = 1